import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Trash2, Search } from "lucide-react";

export function DemoStudentPurge() {
  const [data, setData] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try { setData(await api.get("/admin/purge-demo-students/preview")); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const purge = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/purge-demo-students", { confirm, student_ids: data.students.map((s) => s.id) });
      toast.success(`${r.students_deleted} élève(s) démo supprimé(s)`);
      setConfirm(""); await load();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="mt-8 max-w-2xl rounded-lg border border-red-200 bg-red-50/40 p-5 space-y-3" data-testid="demo-purge-card">
      <h3 className="font-heading font-bold text-red-800">Supprimer les élèves fictifs (démo)</h3>
      <p className="text-sm text-muted-foreground">Ne vise que : Émile Exemple, Zoé Fictif, Adam Modèle, Camille Démo, Gabriel Exemple, Léa Fictif, Manon Démo, Noah Modèle, Thelfort Bernard. « Test Diag » et tous les autres élèves sont conservés.</p>
      <Button variant="outline" onClick={load} disabled={busy} data-testid="demo-purge-preview-btn"><Search className="h-4 w-4 mr-1" />Rechercher ces élèves</Button>
      {data && (data.students.length === 0 ? <p className="text-sm text-emerald-700" data-testid="demo-purge-none">Aucun de ces élèves n'existe dans la base.</p> : (
        <div className="space-y-3" data-testid="demo-purge-result">
          <ul className="text-sm list-disc pl-5" data-testid="demo-purge-list">
            {data.students.map((s) => <li key={s.id}>{s.first_name} {s.last_name} <span className="text-muted-foreground">({s.grade_level || "—"})</span></li>)}
          </ul>
          <p className="text-xs text-muted-foreground" data-testid="demo-purge-related">Données liées : {Object.keys(data.related).length === 0 ? "aucune" : Object.entries(data.related).map(([k, v]) => `${k} : ${v}`).join(" · ")}</p>
          <div className="flex flex-wrap items-center gap-2">
            <Input className="w-48" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Tapez SUPPRIMER" data-testid="demo-purge-confirm-input" />
            <Button variant="destructive" onClick={purge} disabled={busy || confirm !== "SUPPRIMER"} data-testid="demo-purge-delete-btn"><Trash2 className="h-4 w-4 mr-1" />Supprimer définitivement ({data.students.length})</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
